<script>
import { EXAMINATION } from "@/utils/data";
import paperDialog from "./components/paperDialog.vue";
import paperViewDialog from "./components/paperViewDialog.vue";
export default {
  components: { paperDialog, paperViewDialog },
  data() {
    return {
      statusList: EXAMINATION.PAPER_STATUS_LIST,
      statusEnum: EXAMINATION.PAPER_STATUS,
      searchForm: {
        name: "",
        status: "",
      },
      pageInfo: {
        size: 20,
        page: 1,
        total: 0,
      },
      loading: false,
      categoryActive: 0,
      categoryData: [],
      tableData: [],
      paperDialog: {
        visible: false,
        type: "",
        title: "",
        data: {},
      },
      paperViewDialog: {
        visible: false,
        name: "",
        score: "",
        questionList: [],
      },
    };
  },
  mounted() {
    this.handleLoad();
    this.handleLoadCategory();
  },
  methods: {
    handleLoadCategory() {
      // this.$cloud.get("/category/index").then((data) => {
      //   this.categoryData = data;
      //   // this.$nextTick(() => {
      //   //   this.$refs["scrollCategory"].update();
      //   // });
      // });
    },
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.handleLoad();
    },
    handleLoad() {
      this.loading = true;
      this.$cloud
        .get("/examination/paper/list", {
          ...this.pageInfo,
          ...this.searchForm,
          categoryId: this.categoryActive,
        })
        .then((data) => {
          console.log("成员", data);
          this.tableData = data.children;
          this.pageInfo["total"] = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      console.log("提交表单", this.searchForm);
      this.pageInfo.page = 1;
      this.handleLoad();
    },
    handleReset() {
      console.log("重置表单");
      this.searchForm.name = "";
      this.searchForm.status = "";
      this.handleSearch();
    },
    handleStatus(id, status) {
      console.log("修改状态", id, status);
      this.$cloud.post("examination/paper/status", { id, status }).then(() => {
        this.$message.success("操作成功");
        this.handleLoad();
      });
    },
    handleRemove(id) {
      console.log("删除", id);
      this.$cloud.post("examination/paper/remove", { id: id }).then(() => {
        this.$message.success("删除成功");
        this.handleLoad();
      });
    },
    handleCreate() {
      console.log("添加");
      this.paperDialog.data = {};
      this.paperDialog.type = "create";
      this.paperDialog.title = "添加试卷";
      this.paperDialog.visible = true;
    },
    handleView(data) {
      console.log("编辑", data);
      this.paperDialog.data = data;
      this.paperDialog.type = "view";
      this.paperDialog.title = "查看试卷";
      this.paperDialog.visible = true;
    },
    handleEdit(data) {
      console.log("编辑", data);
      this.paperDialog.data = data;
      this.paperDialog.type = "edit";
      this.paperDialog.title = "编辑试卷";
      this.paperDialog.visible = true;
    },
    handleViewPaper(id) {
      console.log("预览试卷", id);
      this.$message.info("加载中");
      this.$cloud.get("examination/paper/detail", { id }).then((res) => {
        console.log("试卷信息", res);
        this.paperViewDialog.name = res.name;
        this.paperViewDialog.score = res.score;
        this.paperViewDialog.questionList = res.questionList;
        this.paperViewDialog.visible = true;
      });
    },
  },
};
</script>
<template>
  <div class="">
    <div class="w-full">
      <div class="flex">
        <div class="flex-grow pr-6">
          <div class="flex h-full">
            <div class="flex-1 ml-4">
              <div class="flex justify-between pt-6">
                <div>
                  <el-button type="primary" @click="handleCreate"
                    >添加</el-button
                  >
                </div>
                <div>
                  <el-form
                    ref="searchForm"
                    :inline="true"
                    :model="searchForm"
                    class="demo-form-inline"
                  >
                    <el-form-item label="试卷名">
                      <el-input
                        v-model="searchForm.name"
                        placeholder="请输入要搜索的试卷名"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select
                        v-model="searchForm.status"
                        placeholder="请选择状态"
                        clearable
                      >
                        <el-option
                          v-for="type in statusList"
                          :key="type.value"
                          :label="type.name"
                          :value="type.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button @click="handleReset">重置</el-button>
                      <el-button @click="handleSearch" type="primary"
                        >查询</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>

              <div>
                <el-table
                  :data="tableData"
                  v-loading="loading"
                  stripe
                  :height="$CSS.CARD_TABLE_HEIGHT"
                  style="width: 100%"
                >
                  <el-table-column type="index" label="编号" width="60">
                  </el-table-column>
                  <el-table-column prop="name" label="考卷名称">
                  </el-table-column>
                  <el-table-column prop="score" label="考卷总分" width="80">
                  </el-table-column>
                  <el-table-column prop="statusName" label="考卷状态">
                    <template slot-scope="scope">
                      <el-tag
                        :type="
                          scope.row.status === statusEnum.ON
                            ? 'success'
                            : 'warning'
                        "
                        >{{ scope.row.statusName }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="createName" label="创建人">
                  </el-table-column>
                  <el-table-column
                    prop="createdTime"
                    label="创建时间"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column width="280" prop="address" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        @click="handleViewPaper(scope.row.id)"
                        class="text-pink-400"
                        type="text"
                        size="small"
                        >预览试卷</el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-button
                        @click="handleStatus(scope.row.id, statusEnum.ON)"
                        v-if="scope.row.status === statusEnum.OFF"
                        class="text-green-400"
                        type="text"
                        size="small"
                        >启用</el-button
                      >
                      <el-button
                        @click="handleStatus(scope.row.id, statusEnum.OFF)"
                        v-else
                        class="text-yellow-400"
                        type="text"
                        size="small"
                        >禁用</el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-button
                        @click="handleView(scope.row)"
                        type="text"
                        size="small"
                        >查看</el-button
                      >
                      <el-divider
                        direction="vertical"
                        v-if="scope.row.status === statusEnum.OFF"
                      ></el-divider>
                      <el-button
                        v-if="scope.row.status === statusEnum.OFF"
                        @click="handleEdit(scope.row)"
                        type="text"
                        size="small"
                        >修改</el-button
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-popconfirm
                        :title="'确定删除【' + scope.row.name + '】吗？'"
                        @confirm="handleRemove(scope.row.id)"
                        v-if="scope.row.status === statusEnum.OFF"
                      >
                        <el-button slot="reference" type="text" size="small"
                          >删除</el-button
                        >
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="py-6">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleLoad"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="pageInfo.page"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pageInfo.size"
                    :total="pageInfo.total"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <paper-dialog
        :visible.sync="paperDialog.visible"
        :title="paperDialog.title"
        :data="paperDialog.data"
        :type="paperDialog.type"
        @refresh="handleLoad"
      />
      <paper-view-dialog
        :visible.sync="paperViewDialog.visible"
        :title="paperViewDialog.name"
        :score="paperViewDialog.score"
        :question-list="paperViewDialog.questionList"
      />
    </div>
  </div>
</template>
<style scoped></style>
